var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "unity-wrap" },
    [
      _c(
        "div",
        { attrs: { id: "unity-container" } },
        [
          _vm.isShowUnity
            ? _c("VueUnity", {
                attrs: {
                  unity: _vm.unityContext,
                  tabindex: "-1",
                  id: "FPGameCanvas",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.isHideLoading
        ? _c("GameLoading", {
            attrs: {
              startGame: _vm.startGame,
              hideLoading: _vm.isHideLoading,
              progress: _vm.progress,
              "loading-text": _vm.loadingText,
            },
            on: {
              play: function ($event) {
                _vm.isHideLoading = true
              },
            },
          })
        : _vm._e(),
      _vm.isShowPopup === "PopupPurchaseComplete"
        ? _c("PopupPurchaseComplete", { on: { close: _vm.popupPCClose } })
        : _vm._e(),
      _vm.isShowVideoPlayer
        ? _c("PopupVideoPlayer", {
            attrs: {
              hideLoading: _vm.isHideLoading,
              options: _vm.videoOptions,
            },
            on: { onVideoEnded: _vm.onVideoEnded },
          })
        : _vm._e(),
      !_vm.isGameStart ? _c("QueuePopup", { ref: "QueuePopup" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }